var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#549bff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 13.75a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-1.5 0v4c0 .414.336.75.75.75zM12 13.75a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-1.5 0v2c0 .414.336.75.75.75zM15 9.25a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75zM15 16.25H9a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#549bff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M17 3.25h-1.426c-.282-.589-.879-1-1.574-1h-4c-.695 0-1.292.411-1.574 1H7A2.752 2.752 0 0 0 4.25 6v13A2.752 2.752 0 0 0 7 21.75h10A2.752 2.752 0 0 0 19.75 19V6A2.752 2.752 0 0 0 17 3.25zm-7 .5h4a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-4A.25.25 0 0 1 9.75 5V4a.25.25 0 0 1 .25-.25zM18.25 19c0 .689-.561 1.25-1.25 1.25H7c-.689 0-1.25-.561-1.25-1.25V6c0-.689.561-1.25 1.25-1.25h1.25V5c0 .965.785 1.75 1.75 1.75h4c.965 0 1.75-.785 1.75-1.75v-.25H17c.689 0 1.25.561 1.25 1.25z",
    opacity: 1,
    "data-original": "#112d55",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockReport);
export default __webpack_public_path__ + "static/media/block-report.22e9f860bdad670a9b7e767236dcf107.svg";
export { ForwardRef as ReactComponent };